import { render } from "./HotDealsList.vue?vue&type=template&id=94908cd0&scoped=true"
import script from "./HotDealsList.vue?vue&type=script&lang=js"
export * from "./HotDealsList.vue?vue&type=script&lang=js"

import "./HotDealsList.vue?vue&type=style&index=0&id=94908cd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94908cd0"]])

export default __exports__